import React, { useState } from 'react'
import { useNavigate } from 'react-router';

const SearchOrder = () => {
    const [query, setQuery] = useState('');
    const navigate = useNavigate();
    function handleSubmit(e) {
        e.preventDefault();
        if (!query) return;
        navigate(`/order/${query}`);
        setQuery("")
    }
    return (
        <form onSubmit={handleSubmit}>
            <input
                placeholder='Search Order #'
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className='rounded-full bg-yellow-100 px-4 py-2 text-sm placeholder:text-stone-400 w-28 sm:w-64 sm:focus:w-72 transition-all duration-300'
            />
        </form>
    )
}

export default SearchOrder